import LocalStorage from "./pre-fill/local-storage";
import LinkedinAutofillBtn from "./pre-fill/linkedin-autofill-btn";

class FormPreFill {
	constructor(drForm) {
		new LocalStorage(drForm);
		new LinkedinAutofillBtn(drForm);
	}
}

export default FormPreFill;
